import { useMemo } from "react";

const featuredGalleryOrder = [
  "2026-tbr-prof-ketan-kotecha-feature.jpeg",
  "2026-tbr-great-conversations-promo.jpeg",
  "2026-tbr-jamal-zaidi-global-impact.jpeg",
  "2026-sunway-university-felicitation.jpeg",
  "2026-malaysia-delegation-group.jpeg",
  "2026-inti-networking-candid.jpeg",
  "2026-tic-conference-welcome.jpeg",
  "2026-inti-spectrum-networking.jpeg",
  "2026-tbr-team-selfie.jpeg",
  "2026-tbr-prof-peter-shepard.jpeg",
  "2026-tea-before-research-solo.jpeg",
  "2026-tbr-prof-ketan-conversation.jpeg",
  "2026-tbr-prof-ketan-certificate.jpeg",
  "2026-tbr-dr-haslina-tea-session.jpeg",
];

const importGalleryImages = () => {
  try {
    const context = require.context(
      "../assets/gallery_images",
      false,
      /\.(png|jpe?g|gif|webp|svg)$/
    );
    return context.keys().map((key) => {
      const src = context(key);
      const fileName = key.replace("./", "");
      const label = fileName
        .replace(/\.[^.]+$/, "")
        .replace(/[-_]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      return {
        src,
        fileName,
        alt: label ? `${label} - gallery` : "Gallery image",
      };
    }).sort((left, right) => {
      const leftIndex = featuredGalleryOrder.indexOf(left.fileName);
      const rightIndex = featuredGalleryOrder.indexOf(right.fileName);

      if (leftIndex !== -1 || rightIndex !== -1) {
        if (leftIndex === -1) return 1;
        if (rightIndex === -1) return -1;
        return leftIndex - rightIndex;
      }

      return left.fileName.localeCompare(right.fileName);
    });
  } catch (error) {
    console.error("Unable to load gallery images:", error);
    return [];
  }
};

const GalleryPage = () => {
  const images = useMemo(() => importGalleryImages(), []);

  return (
    <section id="gallery" className="py-10 space-y-6">
      <div className="space-y-2 text-white">
        <h2 className="text-2xl font-heading text-[#B46A3C] border-b-4 border-[#B46A3C] inline-block pb-1">
          Gallery
        </h2>
        <p className="text-white/80 max-w-3xl">
          
        </p>
      </div>

      {images.length === 0 ? (
        <p className="text-white/70">No gallery images available yet.</p>
      ) : (
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {images.map((image, index) => (
            <figure
              key={`${image.src}-${index}`}
              className="mb-6 rounded-3xl border border-primary/20 bg-[#0f1316] overflow-hidden shadow-xl"
              style={{ breakInside: "avoid" }}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-auto block rounded-2xl"
                loading={index < 3 ? "eager" : "lazy"}
              />
            </figure>
          ))}
        </div>
      )}
    </section>
  );
};

export default GalleryPage;
